export default class InvitationApi {
    /**
     * Store invitation
     *
     * @param data
     * @returns {function(*)}
     */
    static storeInvitation(data) {
        return axios => axios.post('/invitations', data);
    }

    /**
     * Find all instances of the model matched by filter from the data source
     *
     * @param filter
     * @returns {Object}
     */
    static find(filter) {
        return axios => axios.get('/invitations', { filter });
    }

    /**
     * Agree invitation
     *
     * @param token
     * @returns {function(*)}
     */
    static agreeInvitation(token){
        return axios => axios.get(`/invitations/agree/${token}`);
    }

    /**
     * Disagree invitation
     *
     * @param token
     * @returns {function(*)}
     */
    static disagreeInvitation(token){
        return axios => axios.get(`/invitations/disagree/${token}`);
    }
}



// WEBPACK FOOTER //
// ./src/api/invitation.js